export const categories = [
  "All",
  "Frontend",
  "Backend",
  "AI & ML",
  "Career",
  "Roadmaps",
  "Interview Prep",
  "DevOps",
  "Mobile",
];

export const blogPosts = [
  {
    id: 1,
    title: "Mastering React Hooks: A Complete Guide",
    description:
      "Learn how to use React Hooks effectively to build modern, scalable applications with clean and maintainable code.",
    category: "Frontend",
    image:
      "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=600&h=400&fit=crop",
    author: "Sarah Chen",
    authorImage:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    readTime: "8 min",
    date: "Feb 10, 2026",
    slug: "mastering-react-hooks-complete-guide",
    featured: true,
  },
  {
    id: 2,
    title: "Node.js Best Practices for Production",
    description:
      "Discover essential Node.js patterns, performance optimization techniques, and security practices for production environments.",
    category: "Backend",
    image:
      "https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=600&h=400&fit=crop",
    author: "Michael Park",
    authorImage:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    readTime: "10 min",
    date: "Feb 8, 2026",
    slug: "nodejs-best-practices-production",
    featured: false,
  },
  {
    id: 3,
    title: "Introduction to Machine Learning with Python",
    description:
      "Get started with machine learning fundamentals, explore popular libraries, and build your first ML model from scratch.",
    category: "AI & ML",
    image:
      "https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600&h=400&fit=crop",
    author: "Dr. Emily Rodriguez",
    authorImage:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop",
    readTime: "12 min",
    date: "Feb 5, 2026",
    slug: "introduction-machine-learning-python",
    featured: false,
  },
  {
    id: 4,
    title: "How to Negotiate Your First Tech Salary",
    description:
      "Learn proven strategies to confidently negotiate your salary, understand your market value, and secure the best offer.",
    category: "Career",
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop",
    author: "David Kim",
    authorImage:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop",
    readTime: "6 min",
    date: "Feb 3, 2026",
    slug: "negotiate-first-tech-salary",
    featured: false,
  },
  {
    id: 5,
    title: "Full Stack Developer Roadmap 2026",
    description:
      "Your complete guide to becoming a full stack developer. Learn the essential technologies, tools, and skills required.",
    category: "Roadmaps",
    image:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop",
    author: "Jessica Liu",
    authorImage:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    readTime: "15 min",
    date: "Jan 30, 2026",
    slug: "full-stack-developer-roadmap-2026",
    featured: false,
  },
  {
    id: 6,
    title: "Top 50 JavaScript Interview Questions",
    description:
      "Prepare for your next interview with this comprehensive guide covering the most common JavaScript questions and answers.",
    category: "Interview Prep",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop",
    author: "Alex Thompson",
    authorImage:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop",
    readTime: "20 min",
    date: "Jan 28, 2026",
    slug: "top-50-javascript-interview-questions",
    featured: false,
  },
  {
    id: 7,
    title: "Building Responsive UIs with CSS Grid",
    description:
      "Master CSS Grid layout system to create flexible, responsive designs without relying on framework dependencies.",
    category: "Frontend",
    image:
      "https://images.unsplash.com/photo-1507721999472-8ed4421c4af2?w=600&h=400&fit=crop",
    author: "Nina Patel",
    authorImage:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100&h=100&fit=crop",
    readTime: "9 min",
    date: "Jan 25, 2026",
    slug: "building-responsive-uis-css-grid",
    featured: false,
  },
  {
    id: 8,
    title: "RESTful API Design Principles",
    description:
      "Learn how to design scalable, maintainable REST APIs following industry best practices and conventions.",
    category: "Backend",
    image:
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&h=400&fit=crop",
    author: "Carlos Mendez",
    authorImage:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
    readTime: "11 min",
    date: "Jan 22, 2026",
    slug: "restful-api-design-principles",
    featured: false,
  },
  {
    id: 9,
    title: "Deep Learning Fundamentals Explained",
    description:
      "Understand neural networks, backpropagation, and deep learning architectures with practical examples and visualizations.",
    category: "AI & ML",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop",
    author: "Dr. Rachel Foster",
    authorImage:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=100&h=100&fit=crop",
    readTime: "14 min",
    date: "Jan 20, 2026",
    slug: "deep-learning-fundamentals-explained",
    featured: false,
  },
  {
    id: 10,
    title: "Docker and Kubernetes for Beginners",
    description:
      "Start your DevOps journey with containerization. Learn Docker basics and Kubernetes orchestration from scratch.",
    category: "DevOps",
    image:
      "https://images.unsplash.com/photo-1605745341112-85968b19335b?w=600&h=400&fit=crop",
    author: "Tom Anderson",
    authorImage:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=100&h=100&fit=crop",
    readTime: "13 min",
    date: "Jan 18, 2026",
    slug: "docker-kubernetes-beginners",
    featured: false,
  },
  {
    id: 11,
    title: "React Native vs Flutter: Which to Choose?",
    description:
      "Compare React Native and Flutter for mobile development. Learn the pros, cons, and when to use each framework.",
    category: "Mobile",
    image:
      "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&h=400&fit=crop",
    author: "Maya Johnson",
    authorImage:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop",
    readTime: "10 min",
    date: "Jan 15, 2026",
    slug: "react-native-vs-flutter",
    featured: false,
  },
  {
    id: 12,
    title: "Landing Your Dream Tech Job in 2026",
    description:
      "Strategic guide to job hunting in tech. From resume optimization to interview preparation and salary negotiation.",
    category: "Career",
    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop",
    author: "Robert Chen",
    authorImage:
      "https://images.unsplash.com/photo-1463453091185-61582044d556?w=100&h=100&fit=crop",
    readTime: "16 min",
    date: "Jan 12, 2026",
    slug: "landing-dream-tech-job-2026",
    featured: false,
  },
];

export const mentors = [
  {
    id: 1,
    name: "Sarah Chen",
    title: "Senior Frontend Engineer",
    expertise: ["Frontend", "React", "TypeScript"],
    bio: "Passionate about building scalable web applications and mentoring developers. Former tech lead at Google with 8+ years of experience.",
    articles: 24,
    experience: 8,
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&h=300&fit=crop",
    slug: "sarah-chen",
  },
  {
    id: 2,
    name: "Michael Park",
    title: "Backend Architect",
    expertise: ["Backend", "Node.js", "Cloud"],
    bio: "Specializing in microservices and cloud infrastructure. Helping developers master backend development and system design.",
    articles: 31,
    experience: 10,
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop",
    slug: "michael-park",
  },
  {
    id: 3,
    name: "Dr. Emily Rodriguez",
    title: "AI Research Scientist",
    expertise: ["AI & ML", "Python", "Deep Learning"],
    bio: "PhD in Machine Learning with focus on NLP. Making AI accessible through practical tutorials and real-world applications.",
    articles: 18,
    experience: 6,
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&h=300&fit=crop",
    slug: "emily-rodriguez",
  },
  {
    id: 4,
    name: "David Kim",
    title: "Full Stack Developer",
    expertise: ["Full Stack", "React", "Node.js"],
    bio: "Building end-to-end solutions and sharing knowledge on modern web development. Mentor for career transitions into tech.",
    articles: 27,
    experience: 7,
    image:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=300&h=300&fit=crop",
    slug: "david-kim",
  },
];

export const relatedArticles = [
  {
    id: 1,
    title: "Advanced React Patterns You Should Know",
    image:
      "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=400&h=250&fit=crop",
    readTime: "10 min",
    slug: "advanced-react-patterns",
  },
  {
    id: 2,
    title: "State Management in Modern React Apps",
    image:
      "https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=400&h=250&fit=crop",
    readTime: "12 min",
    slug: "state-management-modern-react",
  },
  {
    id: 3,
    title: "Performance Optimization Tips for React",
    image:
      "https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=400&h=250&fit=crop",
    readTime: "8 min",
    slug: "performance-optimization-react",
  },
];

export const getFeaturedPost = () => {
  return blogPosts.find((post) => post.featured) || blogPosts[0];
};

export const getPostsByCategory = (category) => {
  if (category === "All") return blogPosts;
  return blogPosts.filter((post) => post.category === category);
};

export const getPostBySlug = (slug) => {
  return blogPosts.find((post) => post.slug === slug);
};

export const getPostById = (id) => {
  return blogPosts.find((post) => post.id === parseInt(id));
};
